import FeatureCollections from './FeatureCollections'

export default FeatureCollections
